import http from '@/vendor/axios'

export function searchUser (keyword) {
  const url = '/object/res.users/search_users'

  return http.post(url, {
    params: {
      kwargs: {
        query: keyword
      }
    }
  })
}

export function searchUserFromAll (keyword) {
  const url = '/object/res.users/search_users_mention'

  return http.post(url, {
    params: {
      kwargs: {
        query: keyword
      }
    }
  })
}

export function follow (userId) {
  const url = `/object/res.users/${userId}/follow_user`

  return http.post(url, {
    params: {
      data: {}
    }
  })
}

export function unfollow (userId) {
  const url = `/object/res.users/${userId}/unfollow_user`

  return http.post(url, {
    params: {
      data: {}
    }
  })
}

export function getAllUsers () {
  const url = '/object/res.users/list_users'

  return http.post(url, {
    params: {
      data: {}
    }
  })
}
